<form [formGroup]="form">
  <div class="row">
    <div class="col-xxl-8 col-lg-8 box-m-b-5">
      <!--advertiser-->
      <div class="card" *ngIf="roleName === roleEnum.ROLE_ADMIN">
        <div class="card-header p-b-0">
          <div class="d-flex align-items-baseline">
            <i class="icofont icofont-megaphone" style="font-size: 18px"></i>
            <h4 class="ps-2 m-0">
              {{ "campaignDetails.advertiser" | translate }}
            </h4>
          </div>
        </div>
        <div class="card-body">
          <div class="mb-2">
            <label class="col-form-label label"
              >{{ "campaignDetails.advertiser" | translate }} *
            </label>
            <ng-select
              formControlName="advertiser"
              [items]="activatedAdvertisers"
              [multiple]="false"
              [closeOnSelect]="true"
              [placeholder]="
                'advertisingCampaign.create.placeholders.selectAdvertiser'
                  | translate
              "
              [ngClass]="{
                'is-invalid':
                  form.get('advertiser')?.invalid &&
                  form.get('advertiser')?.touched
              }"
              [bindLabel]="'fullName'"
              [searchFn]="searchByName"
              [required]="true"
            >
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div class="mb-0 ml-2">
                  <label class="form-check-label">
                    {{ item.firstName }} {{ item.lastName }} -
                    {{ item.companyName }}
                  </label>
                </div>
              </ng-template>
            </ng-select>
            <div
              class="invalid-feedback"
              *ngIf="
                !form.get('advertiser')?.valid &&
                form.get('advertiser')?.touched
              "
            >
              {{ "errorMsg.validAdvertiser" | translate }}
            </div>
          </div>
        </div>
      </div>
      <!-- Title -->
      <div class="card">
        <div class="card-header p-b-0">
          <div class="d-flex align-items-baseline">
            <i class="icofont icofont-bullhorn" style="font-size: 18px"></i>
            <h4 class="ps-2 m-0">
              {{ "campaignDetails.campaignName" | translate }}
            </h4>
          </div>
        </div>
        <div class="card-body">
          <div class="mb-2">
            <label class="col-form-label label"
              >{{ "campaignDetails.campaignName" | translate }} *
            </label>
            <input
              required
              class="form-control"
              formControlName="title"
              type="text"
              [placeholder]="'placeholder.placeholder_campaign' | translate"
              [ngClass]="{
                'is-invalid':
                  !form.get('title')?.valid && form.get('title')?.touched
              }"
              name="campaignName"
            />
            <div
              class="invalid-feedback"
              *ngIf="!form.get('title')?.valid && form.get('title')?.touched"
            >
              {{ "errorMsg.validTitle" | translate }}
              <ul style="padding-left: 10px">
                <li>
                  {{ "campaignDetails.campaignNameValidator1" | translate }}
                </li>
                <li>
                  {{ "campaignDetails.campaignNameValidator2" | translate }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--programming-->
      <img
        *ngIf="!titleValidator()"
        src="assets/identity/new-campaign/programming-blur.png"
        alt="Card image"
        class="not-valid-img"
      />
      <ng-container *ngIf="titleValidator()">
        <app-campaign-dates
          [startDate]="form.get('startingDate')?.value"
          [endDate]="form.get('endingDate')?.value"
          (datesSelected)="datesSelected($event)"
        ></app-campaign-dates>
      </ng-container>

      <img
        *ngIf="!titleValidator() || !datesValidator()"
        src="assets/identity/new-campaign/choose-by-blur.png"
        alt="Card image"
        class="not-valid-img"
      />
      <!--choose by-->
      <app-campaign-locations
        *ngIf="titleValidator() && datesValidator()"
      ></app-campaign-locations>
    </div>
    <!-- Calculate-->
    <div class="col-12 col-xxl-4 col-lg-4 box-col-6">
      <div
        class="m-r-15"
        style="
          position: sticky;
          justify-items: center;
          top: 9.5%;
          padding: 0px 30px;
        "
      >
        <div class="card" style="width: 350px">
          <div class="card-body pink-background top-radius title-padding">
            <h4>
              <b>{{ "newCampaign.step1.overview.title" | translate }}</b>
            </h4>
            <hr class="white-separator" />
            <div class="row">
              <div class="m-b-5">
                <p>
                  <span class="f-w-600">
                    {{ "campaignDetails.objective" | translate }}: </span
                  ><span class=" ">{{
                    "enumMapping.objectives." + objectiveName | translate
                  }}</span>
                </p>
              </div>
              <div class="m-b-5">
                <p>
                  <span class="f-w-600"
                    >{{
                      "newCampaign.step1.overview.duration" | translate
                    }}: </span
                  ><span
                    >{{ startDate | daysBetweenDates : endDate }}
                    {{ "info.days" | translate }}</span
                  >
                </p>
              </div>
              <div class="m-b-5">
                <p>
                  <span class="f-w-600">
                    {{ "campaignDetails.locations" | translate }}:
                  </span>
                  <span *ngIf="!showAllLocations; else showLocations">
                    {{ castString(selectedLocationsNames) | sliceString : 140 }}
                    <a
                      *ngIf="
                        selectedLocationsNames.length > 0 &&
                        selectedLocationsNames.toString().length >= 140
                      "
                      type="button"
                      style="color: #ffffff; text-decoration: underline"
                      class="font-a"
                      (click)="showAllLocations = true"
                    >
                      <b>{{ "buttons.showMore" | translate }}</b></a
                    >
                  </span>
                  <ng-template #showLocations>
                    <span *ngFor="let lp of selectedLocationsNames">
                      {{ lp }},&ThickSpace;
                    </span>
                    <a
                      type="button"
                      style="color: #ffffff; text-decoration: underline"
                      class="font-a"
                      (click)="showAllLocations = false"
                      ><b>{{ "buttons.showLess" | translate }}</b></a
                    >
                  </ng-template>
                </p>
              </div>
            </div>
          </div>
          <div class="card-body cost-padding">
            <div
              class="card gray-card cost-padding"
              style="margin-bottom: 16px"
            >
              <div class="card-body zero-padding">
                <div class="m-b-5 d-flex align-items-baseline p-r-0">
                  <div class="row" style="width: 100%">
                    <h5>
                      <b>
                        {{
                          "newCampaign.step1.totalResult.estimatedTotalImpression"
                            | translate
                        }}
                      </b>
                    </h5>
                    <hr style="margin: 0 12px 12px" class="black-separator" />
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        min-height: 40px;
                        max-height: 40px;
                      "
                    >
                      <h4
                        class="m-l-5 f-w-500"
                        [ngClass]="
                          totalImpressionsMax ? 'pink-text' : 'gray-text'
                        "
                        [ngStyle]="
                          animating
                            ? { fontSize: '25px', color: '#EE2185' }
                            : { fontSize: '20px' }
                        "
                      >
                        <b *ngIf="totalImpressionsMax">
                          {{ totalImpressionsMin | toKValue }} -
                          {{ totalImpressionsMax | toKValue }}
                        </b>
                        <b *ngIf="!totalImpressionsMax">
                          {{ totalImpressionsMax }}
                        </b>
                      </h4>
                      <div>
                        <img
                          src="assets/svgIcon/stonks.svg"
                          [width]="animating ? '25' : '20'"
                          [height]="animating ? '25' : '20'"
                          [ngClass]="{
                            animating: animating,
                            static: !animating
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="card gray-card cost-padding"
              style="margin-bottom: 16px"
              *ngIf="
                objectiveName == objectiveTypeEnum.WEB_SITE_TRAFFIC ||
                objectiveName == objectiveTypeEnum.GENERATION_DE_PROSPECTS
              "
            >
              <div class="card-body zero-padding">
                <div class="m-b-5 d-flex align-items-baseline p-r-0">
                  <div class="row" style="width: 100%">
                    <h5>
                      <b>
                        {{
                          "newCampaign.step1.totalResult.estimatedTotalClicks"
                            | translate
                        }}
                      </b>
                    </h5>
                    <hr style="margin: 0 12px 12px" class="black-separator" />
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        min-height: 40px;
                        max-height: 40px;
                      "
                    >
                      <h4
                        class="m-l-5 f-w-500"
                        [ngClass]="
                          totalImpressionsMax ? 'pink-text' : 'gray-text'
                        "
                        [ngStyle]="
                          animating
                            ? { fontSize: '25px', color: '#EE2185' }
                            : { fontSize: '20px' }
                        "
                      >
                        <b *ngIf="totalClicksMax">
                          {{ totalClicksMin | toKValue }} -
                          {{ totalClicksMax | toKValue }}
                        </b>
                        <b *ngIf="!totalClicksMax">
                          {{ totalClicksMax }}
                        </b>
                      </h4>
                      <div style="width: '20px'; height: '20px'">
                        <img
                          src="assets/svgIcon/stonks.svg"
                          [width]="animating ? '25' : '20'"
                          [height]="animating ? '25' : '20'"
                          [ngClass]="{
                            animating: animating,
                            static: !animating
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="card gray-card cost-padding"
              style="margin-bottom: 16px"
              *ngIf="objectiveName == objectiveTypeEnum.GENERATION_DE_PROSPECTS"
            >
              <div class="card-body zero-padding">
                <div class="m-b-5 d-flex align-items-baseline p-r-0">
                  <div class="row" style="width: 100%">
                    <h5>
                      <b>
                        {{
                          "newCampaign.step1.totalResult.estimatedTotalLead"
                            | translate
                        }}
                      </b>
                    </h5>
                    <hr style="margin: 0 12px 12px" class="black-separator" />
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        min-height: 40px;
                        max-height: 40px;
                      "
                    >
                      <h4
                        class="m-l-5 f-w-500"
                        [ngClass]="
                          totalImpressionsMax ? 'pink-text' : 'gray-text'
                        "
                        [ngStyle]="
                          animating
                            ? { fontSize: '25px', color: '#EE2185' }
                            : { fontSize: '20px' }
                        "
                      >
                        <b *ngIf="totalLeadsMax">
                          {{ totalLeadsMin | toKValue }} -
                          {{ totalLeadsMax | toKValue }}
                        </b>
                        <b *ngIf="!totalLeadsMax">
                          {{ totalLeadsMax }}
                        </b>
                      </h4>
                      <div style="width: '20px'; height: '20px'">
                        <img
                          src="assets/svgIcon/stonks.svg"
                          [width]="animating ? '25' : '20'"
                          [height]="animating ? '25' : '20'"
                          [ngClass]="{
                            animating: animating,
                            static: !animating
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="card gray-card cost-padding"
              style="margin-bottom: 16px"
            >
              <div class="card-body zero-padding">
                <div class="m-b-5 d-flex align-items-baseline p-r-0">
                  <div class="row" style="width: 100%">
                    <h5>
                      <b>
                        {{
                          "newCampaign.step1.totalResult.estimatedTotalCost"
                            | translate
                        }}
                      </b>
                    </h5>
                    <hr style="margin: 0 12px 12px" class="black-separator" />
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        min-height: 40px;
                        max-height: 40px;
                      "
                    >
                      <h4
                        class="m-l-5 f-w-500"
                        [ngClass]="
                          totalImpressionsMax ? 'pink-text' : 'gray-text'
                        "
                        [ngStyle]="
                          animating
                            ? { fontSize: '25px', color: '#EE2185' }
                            : { fontSize: '20px' }
                        "
                      >
                        <b>{{ totalPrice }} TND HT</b>
                      </h4>
                      <div style="width: '20px'; height: '20px'">
                        <img
                          src="assets/svgIcon/stonks.svg"
                          [width]="animating ? '25' : '20'"
                          [height]="animating ? '25' : '20'"
                          [ngClass]="{
                            animating: animating,
                            static: !animating
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
